/*------------------------------------*\
    profile pic
\*------------------------------------*/
module.exports = function(){



    $('.js-profile-pic-form').on('submit', function(event) {
        event.preventDefault();
        var form = this;


        //new jBox('Notice', {
        //    content: 'Uploading profile picture...',
        //    //position: {
        //    //    x: 'center',
        //    //    y: 'top'
        //    //},
        //});


        $(form).find('.js-profile-pic-label').addClass('is-uploading');




        var data = new FormData();

        data.append('profile_picture', $(this).find('.js-profile-pic-input')[0].files[0]);

        $.ajax({
            url: $(form).attr('action'),
            type: $(form).attr('method'),
            cache: false,
            contentType: false,
            processData: false,
            data: data,
            headers: {
                //'Content-Type': 'multipart/form-data; boundary=__X_PAW_BOUNDARY__',
                'Authorization': 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN')
            },

            complete: function(jqXHR, textStatus){
                console.log(jqXHR);



                new jBox('Notice', {
                    content: 'Profile picture uploaded!',
                    attributes: {
                        x: 'right',
                        y: 'bottom'
                    }
                });



            },

            success: function(data, textStatus, jqXHR){

                var newSrc = EPH_S3_CDN + '/' + data.data.filename;

                $('.js-profile-pic-img').one('load', function(event) {
                    $(form).find('.js-profile-pic-label').removeClass('is-uploading');
                });

                $('.js-profile-pic-img').attr('src', newSrc);

            },

            error: function(jqXHR, textStatus, errorThrown){

            },

        });



    });


    $('.js-profile-pic-input').on('input', function(event) {
        $('.js-profile-pic-form').trigger('submit');
    });





}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/profile-pic.js